import { render, staticRenderFns } from "./FeedbackLink.vue?vue&type=template&id=38634028&scoped=true"
import script from "./FeedbackLink.vue?vue&type=script&lang=js"
export * from "./FeedbackLink.vue?vue&type=script&lang=js"
import style0 from "./FeedbackLink.vue?vue&type=style&index=0&id=38634028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38634028",
  null
  
)

export default component.exports